import { EPromptOptimizationJobStatus } from '@/types/schema';

const formatter = new Intl.DateTimeFormat('en-US', {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  timeZoneName: 'short',
});

export function formatDate(date: string) {
  return formatter.format(new Date(date));
}

export function getStyleFromStatus(status: EPromptOptimizationJobStatus) {
  switch (status) {
    case EPromptOptimizationJobStatus.SUCCESSFUL:
      return 'bg-success-primary text-success-primary border-[#ACEFC6]';
    case EPromptOptimizationJobStatus.FAILED:
      return 'bg-error-primary text-error border-[#FECDCA]';
    case EPromptOptimizationJobStatus.RUNNING:
      return 'bg-[#EFF8FF] text-[#175CD3] border-[#B2DDFF]';
    case EPromptOptimizationJobStatus.CREATED:
      return 'bg-background text-secondary border border-secondary';
  }
}

export function getStatusLabel(status: EPromptOptimizationJobStatus) {
  switch (status) {
    case EPromptOptimizationJobStatus.SUCCESSFUL:
      return 'Complete';
    case EPromptOptimizationJobStatus.FAILED:
      return 'Failed';
    case EPromptOptimizationJobStatus.RUNNING:
      return 'Running';
    case EPromptOptimizationJobStatus.CREATED:
      return 'Created';
  }
}
